
export const CONFIG_TAG = "EVENT_MANAGEMENT";

export const EVENT_MANAGEMENT_STRINGS : any = { 
  TITLE : `${CONFIG_TAG}.TITLE`,
  EVENT_TYPE_TITLE : `${CONFIG_TAG}.EVENT_TYPE_TITLE`,
  TAB_LABELS : {
    ACTIVE : `${CONFIG_TAG}.TAB_LABEL.ACTIVE`,
    PAST : `${CONFIG_TAG}.TAB_LABEL.PAST`
  },
  EVENT_TYPE : {
    ALL : `${CONFIG_TAG}.EVENT_TYPE.ALL`,
    CPP : `${CONFIG_TAG}.EVENT_TYPE.CPP`,
    EV_CPE : `${CONFIG_TAG}.EVENT_TYPE.EV_CPE`,
  },
  ONGOING : {
    TITLE : `${CONFIG_TAG}.ONGOING_EVENTS.TITLE`
  },
  SCHEDULED : {
    TITLE : `${CONFIG_TAG}.SCHEDULED_EVENTS.TITLE`
  },
  PAST : {
    DESCRIPTION : `${CONFIG_TAG}.PAST_EVENTS.DESCRIPTION_TEXT`,
    FIELDS : {
      NAME : `${CONFIG_TAG}.PAST_EVENTS.FIELDS.NAME`,
      CREATED_ON : `${CONFIG_TAG}.PAST_EVENTS.FIELDS.CREATED_ON`,
      ACTIONS : `${CONFIG_TAG}.PAST_EVENTS.FIELDS.ACTIONS`
    },
    DETAILS : `${CONFIG_TAG}.PAST_EVENTS.DETAILS`
  },
  ERROR : {
    TITLE : `${CONFIG_TAG}.ERROR.TITLE`,
    SUBTEXT : `${CONFIG_TAG}.ERROR.SUBTEXT`,
    RELOAD : `${CONFIG_TAG}.ERROR.RELOAD`
  },
  NO_DATA : {
    TITLE : `${CONFIG_TAG}.NO_DATA.TITLE`,
    SUBTEXT : `${CONFIG_TAG}.NO_DATA.SUBTEXT`,
    PAST_EVENTS : {
      TITLE : `${CONFIG_TAG}.PAST_EVENTS.NO_DATA.TITLE`,
      SUBTEXT : `${CONFIG_TAG}.PAST_EVENTS.NO_DATA.SUBTEXT`
    }
  },
  ACTIONS : {
    EDIT : `${CONFIG_TAG}.ACTIONS.EDIT_EVENT`,
    DUPLICATE : `${CONFIG_TAG}.ACTIONS.DUPLICATE_EVENT`,
    DELETE : `${CONFIG_TAG}.ACTIONS.DELETE_EVENT`,
    SCHEDULE : `${CONFIG_TAG}.ACTIONS.SCHEDULE_EVENT`
  },
  DATE : {
    START : `${CONFIG_TAG}.START_DATE`,
    END : `${CONFIG_TAG}.END_DATE`
  },
  EVENT_STARTS_IN : `${CONFIG_TAG}.EVENT_STARTS_IN`,
  EVENT_ENDS_IN : `${CONFIG_TAG}.EVENT_ENDS_IN`,
  COMMUNICATIONS : {
    TITLE : `${CONFIG_TAG}.COMMUNICATIONS.TITLE`,
    FIELDS : {
      EMAIL : `${CONFIG_TAG}.COMMUNICATIONS.FIELD.EMAIL`,
      DATE : `${CONFIG_TAG}.COMMUNICATIONS.FIELD.DATE`,
      STATUS : `${CONFIG_TAG}.COMMUNICATIONS.FIELD.STATUS`
    }
  },
  EVENT_STATUS : {
    SCHEDULED : `${CONFIG_TAG}.EVENT_STATUS.SCHEDULED`,
    SENT : `${CONFIG_TAG}.EVENT_STATUS.SENT`,
    FAILED : `${CONFIG_TAG}.EVENT_STATUS.FAILED`
  },
  VALIDATIONS : {
    INVALID_DATE_TIME : `${CONFIG_TAG}.VALIDATIONS.INVALID_DATE_TIME`
  },
  INPUT_PLACEHOLDERS : {
    SELECT_EVENT_TYPE : `${CONFIG_TAG}.INPUT_PLACEHOLDER.SELECT_EVENT_TYPE`,
    DATE : `${CONFIG_TAG}.INPUT_PLACEHOLDER.DATE`,
    EVENT_NAME : `${CONFIG_TAG}.INPUT_PLACEHOLDER.EVENT_NAME`,
  },
  POPUP : {
    BTN : {
      CANCEL : `${CONFIG_TAG}.POPUP.BTN.CANCEL`,
      SCHEDULE : `${CONFIG_TAG}.POPUP.BTN.SCHEDULE`,
      TRY_AGAIN : `${CONFIG_TAG}.POPUP.BTN.TRY_AGAIN`,
      SAVE : `${CONFIG_TAG}.POPUP.BTN.SAVE`,
      CLOSE : `${CONFIG_TAG}.POPUP.BTN.CLOSE`,
      DELETE : `${CONFIG_TAG}.POPUP.BTN.DELETE`,
    },
    FIELD_LABEL : {
      TYPE : `${CONFIG_TAG}.POPUP.FIELD.TYPE`,
      START_DATE : `${CONFIG_TAG}.POPUP.FIELD.START_DATE`,
      END_DATE : `${CONFIG_TAG}.POPUP.FIELD.END_DATE`,
      DURATION : `${CONFIG_TAG}.POPUP.FIELD.DURATION`,
      NAME : `${CONFIG_TAG}.POPUP.FIELD.NAME`
    },
    MESSAGE : {
      SAVING : `${CONFIG_TAG}.POPUP.MESSAGE.SAVING`,
      SCHEDULING : `${CONFIG_TAG}.POPUP.MESSAGE.SCHEDULING`,
      SAVED : `${CONFIG_TAG}.POPUP.MESSAGE.SAVED`,
      SCHEDULED : `${CONFIG_TAG}.POPUP.MESSAGE.SCHEDULED`,
      DELETING : `${CONFIG_TAG}.POPUP.MESSAGE.DELETING`,
      CONFIRM_DELETE : `${CONFIG_TAG}.POPUP.MESSAGE.CONFIRM_DELETE`,
      PILOT_TIMEZONE_INFO : `${CONFIG_TAG}.POPUP.MESSAGE.PILOT_TIMEZONE_INFO`,
      PILOT_TIMEZONE_EMAIL : `${CONFIG_TAG}.POPUP.MESSAGE.PILOT_TIMEZONE_EMAIL`
    }
  },
  EDIT_POPUP : {
    TITLE : `${CONFIG_TAG}.EDIT_POPUP.TITLE`,
  },
  SCHEDULE_POPUP : {
    TITLE : `${CONFIG_TAG}.SCHEDULE_POPUP.TITLE`
  }
}
